import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import GallectionsGrid from '../GallectionGrid';
import SearchInput from '../../_partials/SearchInput';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import FolderCard from '../../_partials/FolderCard';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import withGallections from '../../_hocs/withGallections';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
const enhance = compose(withGallections, withMobileContext, withTranslation());
export class GallectionExplorer extends React.Component {
    render() {
        const { disableSearch } = this.props;
        return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerExtrasRightZone: disableSearch ? undefined : /*#__PURE__*/ React.createElement(SearchInput, null),
            scrollableContent: this.renderContent(),
            onScrolledToBottom: this.fetchMoreGallectionsIfNeeded,
            onNotScrollable: this.fetchMoreGallectionsIfNeeded
        });
    }
    renderContent() {
        const { isGallectionStreamInitialized, gallections, hasMoreGallections } = this.props;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isGallectionStreamInitialized && /*#__PURE__*/ React.createElement(GallectionsGrid, {
            cookieType: MeasuredCookieType.GALLECTION_EXPLORER,
            gallections: gallections,
            gallectionRenderer: this.renderGallection
        }), hasMoreGallections && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !gallections.length && hasMoreGallections
        }));
    }
    constructor(...args){
        super(...args), _define_property(this, "fetchMoreGallectionsIfNeeded", ()=>{
            const { hasMoreGallections, isFetchingGallections, fetchMoreGallections } = this.props;
            if (!hasMoreGallections || isFetchingGallections) {
                return;
            }
            fetchMoreGallections();
        }), _define_property(this, "renderGallection", ({ index, width })=>{
            const { gallections } = this.props;
            const gallection = gallections[index];
            return /*#__PURE__*/ React.createElement(FolderCard, {
                width: width,
                folder: gallection
            });
        });
    }
}
export default enhance(GallectionExplorer);

//# sourceMappingURL=GallectionExplorer.js.map